import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import axios from '@/utils/axios';  // 导入配置好的 axios 实例

Vue.use(ElementUI)

Vue.config.productionTip = false
// 将 axios 挂载到 Vue 实例上，方便全局使用
Vue.prototype.$axios = axios;
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
